export default (function (a, c, d) {
  var e, f, h;

  if (e = f = h = d, c) {
    var i = function i(a, b, c) {
      return 0 > c && c++, 1 < c && c--, c < 1 / 6 ? a + 6 * (b - a) * c : c < 1 / 2 ? b : c < 2 / 3 ? a + 6 * ((b - a) * (2 / 3 - c)) : a;
    },
        j = .5 > d ? d * (1 + c) : d + c - d * c,
        k = 2 * d - j;

    e = i(k, j, a + 1 / 3), f = i(k, j, a), h = i(k, j, a - 1 / 3);
  }

  return [255 * e, 255 * f, 255 * h].map(Math.round);
});